import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { LocalizedRouterService } from '@app/shared/services/localized-router.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WordpressContentApiService } from '@app/shared/services/wordpress-content-api.service';
import { TrackingParametersComponent } from '@app/unauthenticated/trackingParameters.component';

@Component({
  selector: 'app-whistleblowing',
  templateUrl: './whistleblowing.component.html',
  styleUrls: ['./whistleblowing.component.scss'],
})
export class WhistleblowingComponent extends TrackingParametersComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  constructor(@Inject(PLATFORM_ID) platformId: Object, private translate: TranslateService) {
    super(platformId);
  }

  ngOnInit(): void {
    this.translate.onLangChange.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {});
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
